import { render, staticRenderFns } from "./catelist.vue?vue&type=template&id=0c83f63e&scoped=true"
import script from "./catelist.vue?vue&type=script&lang=js"
export * from "./catelist.vue?vue&type=script&lang=js"
import style0 from "./catelist.vue?vue&type=style&index=0&id=0c83f63e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83f63e",
  null
  
)

export default component.exports